import { call, put, takeEvery } from 'redux-saga/effects'
import * as roleGroupActions from '../ducks/roleGroupDucks'
import * as roleGroupApi from '../../api/roleGroupApi'

interface FetchSaga {
  type: string
  payload: string
}

function* fetchListRoleGroup({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof roleGroupApi.getListRoleGroup> = yield call(roleGroupApi.getListRoleGroup, queryString)
    yield put(roleGroupActions.getListRoleGroupSuccess(res))
  } catch (error) {
    yield put(roleGroupActions.getListRoleGroupFail(error))
  }
}

function* fetchListOptionRoleGroup({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof roleGroupApi.getListOptionRoleGroup> = yield call(roleGroupApi.getListOptionRoleGroup, queryString)
    yield put(roleGroupActions.getListOptionRoleGroupSuccess(res))
  } catch (error) {
    yield put(roleGroupActions.getListOptionRoleGroupFail(error))
  }
}


function* fetchDetailRoleGroup({ payload: id }: FetchSaga) {
  try {
    const res: ReturnType<typeof roleGroupApi.getDetailRoleGroup> = yield call(roleGroupApi.getDetailRoleGroup, id)
    yield put(roleGroupActions.getDetailRoleGroupSuccess(res))
  } catch (error) {
    yield put(roleGroupActions.getDetailRoleGroupFail(error))
  }
}


export default function* watchRoleGroup() {
  yield takeEvery(roleGroupActions.getListRoleGroup.toString(), fetchListRoleGroup)
  yield takeEvery(roleGroupActions.getListOptionRoleGroup.toString(), fetchListOptionRoleGroup)
  yield takeEvery(roleGroupActions.getDetailRoleGroup.toString(), fetchDetailRoleGroup)
}
